// src/modules/app-views/products/pages/Document/components/CardHeaderProductIcons.jsx
// *******************************************************************************
// PRODUCT CARD HEADER ICONS
// *******************************************************************************
// Displays product characteristic icons based on composable stock model:
// Channels (store/web), Tracking (serial/lot), Unique, Variants.
// Also includes standard DocumentInfoIcons (origin, enrichment).
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import {
  GlobalOutlined,
  ShopOutlined,
  BarcodeOutlined,
  NumberOutlined,
  AppstoreOutlined,
  StarOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';
import DocumentInfoIcons from 'components/JarvislyComponents/DocumentInfoIcons';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderProductIcons = ({ data }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const stock = data?.stock || {};
  const channels = stock.channels || [];
  const hasStore = channels.includes('store');
  const hasWeb = channels.includes('web');
  const isSerial = stock.tracking === 'serial';
  const isLot = stock.tracking === 'lot';
  const hasVariants = stock.variantMode && stock.variantMode !== 'none';
  const isUnique = stock.isUnique === true;

  const iconStyle = { fontSize: 18, color: '#8c8c8c' };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      {/* Standard document origin/enrichment icons */}
      <DocumentInfoIcons data={data} size={18} />

      {/* Channel icons */}
      {hasStore && (
        <Tooltip title={translateX('store_channel')}>
          <ShopOutlined style={iconStyle} />
        </Tooltip>
      )}
      {hasWeb && (
        <Tooltip title={translateX('web_channel')}>
          <GlobalOutlined style={iconStyle} />
        </Tooltip>
      )}

      {/* Tracking icons */}
      {isSerial && !isUnique && (
        <Tooltip title={translateX('tracking_serial')}>
          <NumberOutlined style={iconStyle} />
        </Tooltip>
      )}
      {isUnique && (
        <Tooltip title={translateX('unique_item')}>
          <StarOutlined style={iconStyle} />
        </Tooltip>
      )}
      {isLot && (
        <Tooltip title={translateX('tracking_lot')}>
          <BarcodeOutlined style={iconStyle} />
        </Tooltip>
      )}

      {/* Variants icon */}
      {hasVariants && (
        <Tooltip title={stock.variantMode === 'single_attribute' ? translateX('grid_1d') : translateX('grid_2d')}>
          <AppstoreOutlined style={iconStyle} />
        </Tooltip>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderProductIcons;
